import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductShowcase() {
  return <section className="pt-20 pb-8 px-4 bg-brand-light" data-id="element-265">
      <div className="max-w-5xl mx-auto text-center" data-id="element-266">
        <div className="inline-flex items-center justify-center gap-2 bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full mb-6" data-id="element-267">
          <span data-id="element-268">🏆</span> El único Mega Pack de carpintería en acero de
          Argentina
        </div>

        <h2 className="text-4xl md:text-6xl font-black text-brand-dark mb-4" data-id="element-269">
          🔥 ARSENAL DEL SOLDADOR 24HS
        </h2>
        <h3 className="text-3xl md:text-4xl font-extrabold text-brand-amber mb-8" data-id="element-270">
          MEGA PACK COMPLETO
        </h3>

        <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12" data-id="element-271">
          5 Tomos Maestros con 390 páginas. Planos, costos, guiones de venta y
          sistema completo. 3 bonos de regalo. Todo listo para empezar hoy.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-272">
          {['T1', 'T2', 'T3', 'T4', 'T5'].map(tomo => <div key={tomo} className="w-16 h-16 bg-white rounded-xl shadow-md flex items-center justify-center text-2xl font-black text-brand-steel border-2 border-brand-steel/10" data-id="element-273">
              {tomo}
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-274">
          <div className="text-left bg-white p-8 rounded-2xl shadow-xl" data-id="element-275">
            <h4 className="text-2xl font-black text-brand-dark mb-6 border-b pb-4" data-id="element-276">
              5 TOMOS MAESTROS
            </h4>
            <ul className="space-y-4" data-id="element-277">
              {['Sistema paso a paso', 'Planos y medidas exactas', 'Guiones de venta incluidos', '3 bonos de regalo'].map((item, i) => <li key={i} className="flex items-center gap-3 text-xl font-bold text-gray-800" data-id="element-278">
                  <CheckCircleIcon className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-279" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-280">
            <a href="https://checkout.guiadigital360.online/cart/43889650401349:1" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" data-id="element-281">
              <img src="https://cdn.magicpatterns.com/uploads/2FfumGWEQBmcJHzgog7GL7/heylloyd-image-1773353141010.png" alt="Arsenal del Soldador 24hs — Mega Pack Maestro Carpintero del Acero" className="w-full drop-shadow-2xl" data-id="element-282" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}